import { render, staticRenderFns } from "./UserAccessList.vue?vue&type=template&id=96e91a5c&"
import script from "./UserAccessList.vue?vue&type=script&lang=js&"
export * from "./UserAccessList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports